// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListA2_comp__Rl3Bb"};